'use client';
import { useState } from 'react';
import { useRouter, useSearchParams, usePathname } from 'next/navigation';
import algoliasearch from 'algoliasearch/lite';
import { Configure, InstantSearch } from 'react-instantsearch';

//* Components
import { Container, Text } from '@weareconceptstudio/core';
import SearchBox from '@/components/search/SearchBox';
import Hits from '@/components/search/Hits';
import Pagination from '@/components/search/Pagination';

//* Style
import SearchStyle from './style';

const algoliaIndexPrefix = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_PREFIX;
const algoliaImagePrefix = process.env.NEXT_PUBLIC_ALGOLIA_IMAGE_PREFIX;

const algoliaClient = algoliasearch(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID, process.env.NEXT_PUBLIC_ALGOLIA_SECRET);

const SearchTemplate = () => {
	const router = useRouter();
	const searchParams = useSearchParams();

	const queryParam = searchParams.get('q') || '';
	const pageParam = parseInt(searchParams.get('page') || '1', 10);

	const [initialQuery, setInitialQuery] = useState(queryParam);
	const [resultCount, setResultCount] = useState(0);

	const searchClient = {
		...algoliaClient,
		search: async (requests) => {
			const res = await algoliaClient.search(requests);
			const count = res.results.reduce((sum, r) => sum + r.nbHits, 0);
			setResultCount(count);
			return res;
		},
	};

	// inside SearchTemplate
	const pathname = usePathname(); // get current path

	const handleSearchStateChange = ({ uiState }) => {
		const searchIndexState = uiState[`${algoliaIndexPrefix}_index`] || {};
		const searchQuery = searchIndexState.query || '';
		const searchPage = (searchIndexState.page || 0) + 1;

		const newQuery = Object.fromEntries(searchParams.entries());
		if (searchQuery) newQuery.q = searchQuery;
		else delete newQuery.q;

		if (searchPage > 1) newQuery.page = searchPage;
		else delete newQuery.page;

		const url = `${pathname}?${new URLSearchParams(newQuery).toString()}`;

		if (searchQuery !== queryParam || searchPage !== pageParam) {
			router.replace(url);
			setInitialQuery(searchQuery);
		}
	};

	const handleClearSearchParam = () => {
		const url = `${pathname}`;
		router.replace(url);
		setInitialQuery('');
	};

	return (
		<SearchStyle>
			<Container>
				<Text
					tag='h1'
					text='search'
					className='h2 black-900 montserrat-400 title'
				/>

				<InstantSearch
					searchClient={searchClient}
					indexName={`${algoliaIndexPrefix}_index`}
					onStateChange={handleSearchStateChange}
					initialUiState={{
						[`${algoliaIndexPrefix}_index`]: {
							query: initialQuery,
							page: pageParam,
						},
					}}>
					<SearchBox
						initialQuery={initialQuery}
						onClear={handleClearSearchParam}
					/>
					<Configure hitsPerPage={12} />
					<Hits imagePrefix={algoliaImagePrefix} />
					<Pagination
						perPage={12}
						totalHits={resultCount}
					/>
				</InstantSearch>
			</Container>
		</SearchStyle>
	);
};

export default SearchTemplate;
